import React, { FC } from 'react';
import AICard from './AICard';
import styles from './AIApplicationList.module.scss';

interface AppItem {
  /** 卡片图标 */
  icon: string;
  /** 卡片标题 */
  title: string;
  /** 卡片副标题 */
  subTitle: string;
  /** 卡片描述 */
  description: string;
}

interface Props {
  /** 列表标题 */
  title: string;
  /** AI 应用场景列表数据 */
  appDataArr: AppItem[];
}

/**
 * AI 应用生活列表组件
 * 展示 AI 在生活场景中应用的卡片列表
 */
const AIApplicationList: FC<Props> = (props) => {
  const { title, appDataArr } = props;

  return (
    <div className={styles['ai-application-list']}>
      <div className={styles['ai-application-list-container']}>
        <h2 className={styles['ai-application-list-title']}>{title}</h2>
        <div className={styles['ai-application-list-grid']}>
          {appDataArr.map((data, index) => (
            <AICard key={index} {...data} />
          ))}
        </div>
      </div>
    </div>
  );
};

AIApplicationList.displayName = 'AIApplicationList';
export default AIApplicationList;
